export default __webpack_public_path__ + "static/media/Harness of Quilled Darts.8a745e07.jpg";